import { MutationTree } from 'vuex';
import { WidgetState } from './types';
import { IPaymentOptionGroup, IProperty, IWidget } from '@resclick/data-access';
import { SUPPORTED_CURRENCIES } from '@resclick/data-access';
const supportedCurrencies = SUPPORTED_CURRENCIES.map((currency) => currency.code);

export const mutations: MutationTree<WidgetState> = {
  widgetLoaded(state, payload: IWidget & { property: IProperty }) {
    state.error = false;
    state.isLoaded = true;
    state.settings = payload;

    if (!supportedCurrencies.includes(state.settings.market?.currency as any)) {
      if (!state.settings.market) state.settings.market = { currency: 'EUR' };
      (state.settings.market as any).currency = 'EUR';
    }

    const { injections = [] } = payload || {};

    const bookingInjections = injections.filter((injection: any) => injection.locations?.includes('BOOKING_PAGE'));

    const ref = document.querySelector('script');

    for (const injection of bookingInjections) {
      const code = injection.code.trim();
      switch (injection.type) {
        case 'JAVASCRIPT': {
          eval(code);
          break;
        }
        case 'CSS':
        case 'GLOBAL_CSS': {
          const style = document.createElement('style');
          style.innerHTML = code;
          ref?.parentNode?.insertBefore(style, ref);
          break;
        }
        case 'GOOGLE_ANALYTICS': {
          const gaScript = document.createElement('script');
          gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${code}`;
          gaScript.defer = true;
          ref?.parentNode?.insertBefore(gaScript, ref);

          const triggerScript = document.createElement('script');
          triggerScript.innerHTML = `
window.dataLayer = window.dataLayer || [];
function gtag() {dataLayer.push(arguments);}
gtag("js", new Date());
gtag("config", "${code}");`;

          ref?.parentNode?.insertBefore(triggerScript, ref);
          break;
        }
        case 'GOOGLE_TAG_MANAGER': {
          const gtagScript = document.createElement('script');
          gtagScript.innerHTML = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${code}');`;
          ref?.parentNode?.insertBefore(gtagScript, ref);

          const triggerScript = document.createElement('noscript');
          triggerScript.innerHTML = `
<iframe src="https://www.googletagmanager.com/ns.html?id=${code}"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

          document.body.append(triggerScript);
        }
      }
    }
  },
  widgetLoadingError(state) {
    state.error = true;
    state.isLoaded = false;
    state.settings = {
      isActive: false,
      name: '',
      logo: {} as any,
      type: 'BOOKING_WIDGET',
      company: '',
      property: '',
      theme: '',
      phoneNumber: '',
      style: {},
      injections: [],
      market: {},
    };
  },
};
